import {SalesTicketVo} from '../../../common/shared/api/nicolas/vo/SalesTicketVo.interface';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';

export function getSalesTicketPaidText(salesTicket: SalesTicketVo): string {
  return formatWithCommas(
    salesTicket.price * salesTicket.paid_num * salesTicket.qty
  );
}
